/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * MDLink
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {AddUsersToRoleBody} from './schemas/add-users-to-role-body';

import type {CreateRoleBody} from './schemas/create-role-body';

import type {CreateRole201} from './schemas/create-role201';

import type {ExportRolesCsv200} from './schemas/export-roles-csv200';

import type {ListPermissionsParams} from './schemas/list-permissions-params';

import type {ListPermissions200} from './schemas/list-permissions200';

import type {ListRoleUsersParams} from './schemas/list-role-users-params';

import type {ListRoleUsers200} from './schemas/list-role-users200';

import type {ListRolesParams} from './schemas/list-roles-params';

import type {ListRoles200} from './schemas/list-roles200';

import type {RemoveUsersFromRoleBody} from './schemas/remove-users-from-role-body';

import type {RetrieveRoleParams} from './schemas/retrieve-role-params';

import type {RetrieveRole200} from './schemas/retrieve-role200';

import type {UpdateRoleBody} from './schemas/update-role-body';

import type {UpdateRole200} from './schemas/update-role200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List all role users
 */
export const listRoleUsers = (
  id: number,
  params?: ListRoleUsersParams,
  options?: SecondParameter<typeof orvalApiFetch<ListRoleUsers200>>,
) => {
  return orvalApiFetch<ListRoleUsers200>(
    {url: `/roles/${id}/users`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Add users to a role
 */
export const addUsersToRole = (
  id: number,
  addUsersToRoleBody: AddUsersToRoleBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/roles/${id}/users/add`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: addUsersToRoleBody,
    },
    options,
  );
};
/**
 * @summary Remove users from a role
 */
export const removeUsersFromRole = (
  id: number,
  removeUsersFromRoleBody: RemoveUsersFromRoleBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/roles/${id}/users/remove`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: removeUsersFromRoleBody,
    },
    options,
  );
};
/**
 * @summary List all roles
 */
export const listRoles = (
  params?: ListRolesParams,
  options?: SecondParameter<typeof orvalApiFetch<ListRoles200>>,
) => {
  return orvalApiFetch<ListRoles200>(
    {url: `/roles`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Create a role
 */
export const createRole = (
  createRoleBody: CreateRoleBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateRole201>>,
) => {
  return orvalApiFetch<CreateRole201>(
    {
      url: `/roles`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createRoleBody,
    },
    options,
  );
};
/**
 * @summary Retrieve a role
 */
export const retrieveRole = (
  id: number,
  params?: RetrieveRoleParams,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveRole200>>,
) => {
  return orvalApiFetch<RetrieveRole200>(
    {url: `/roles/${id}`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Update a role
 */
export const updateRole = (
  id: number,
  updateRoleBody?: UpdateRoleBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateRole200>>,
) => {
  return orvalApiFetch<UpdateRole200>(
    {
      url: `/roles/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: updateRoleBody,
    },
    options,
  );
};
/**
 * @summary Delete a role
 */
export const deleteRole = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>({url: `/roles/${id}`, method: 'DELETE'}, options);
};
/**
 * @summary Export roles as CSV
 */
export const exportRolesCsv = (
  options?: SecondParameter<typeof orvalApiFetch<ExportRolesCsv200>>,
) => {
  return orvalApiFetch<ExportRolesCsv200>(
    {url: `/roles/csv/export`, method: 'POST'},
    options,
  );
};
/**
 * @summary List all permissions
 */
export const listPermissions = (
  params: ListPermissionsParams,
  options?: SecondParameter<typeof orvalApiFetch<ListPermissions200>>,
) => {
  return orvalApiFetch<ListPermissions200>(
    {url: `/permissions`, method: 'GET', params},
    options,
  );
};
export type ListRoleUsersResult = NonNullable<
  Awaited<ReturnType<typeof listRoleUsers>>
>;
export type AddUsersToRoleResult = NonNullable<
  Awaited<ReturnType<typeof addUsersToRole>>
>;
export type RemoveUsersFromRoleResult = NonNullable<
  Awaited<ReturnType<typeof removeUsersFromRole>>
>;
export type ListRolesResult = NonNullable<
  Awaited<ReturnType<typeof listRoles>>
>;
export type CreateRoleResult = NonNullable<
  Awaited<ReturnType<typeof createRole>>
>;
export type RetrieveRoleResult = NonNullable<
  Awaited<ReturnType<typeof retrieveRole>>
>;
export type UpdateRoleResult = NonNullable<
  Awaited<ReturnType<typeof updateRole>>
>;
export type DeleteRoleResult = NonNullable<
  Awaited<ReturnType<typeof deleteRole>>
>;
export type ExportRolesCsvResult = NonNullable<
  Awaited<ReturnType<typeof exportRolesCsv>>
>;
export type ListPermissionsResult = NonNullable<
  Awaited<ReturnType<typeof listPermissions>>
>;
